import styled from 'styled-components';

import { RenderMode } from './Info';

export const BaseWrapper = styled.div``;

export const Wrapper = styled(BaseWrapper)`
  display: flex;
  flex-direction: column;
`;

interface AddressProps {
  mode: RenderMode;
}

export const AddressContainer = styled(BaseWrapper)<AddressProps>`
  margin-top: ${props => (props.mode === 'Basic' ? '24px' : '0px')};
  margin-bottom: 9px;
`;

export const InputContainer = styled(BaseWrapper)`
  margin: 16px 0 8px;
`;
